/**
 * COFFEE HERO PRODUCT: Interactive Engine
 * Variant switching, quantity, delivery (SK/CZ with holidays), freshness, add-to-cart.
 */
(function () {
  'use strict';

  // ── i18n ──
  // The section renders every runtime string through the theme translation
  // system into #chp-i18n (see coffee-hero-product.liquid). Czech literals
  // below stay as fallbacks so a missing payload can never blank the UI.
  var I18N = {};
  try {
    var i18nEl = document.getElementById('chp-i18n');
    if (i18nEl) I18N = JSON.parse(i18nEl.textContent) || {};
  } catch (e) { I18N = {}; }
  function T(key, fallback) {
    var s = I18N[key];
    return (typeof s === 'string' && s) ? s : fallback;
  }
  // Placeholder-substituting variant: sub is a {__N__: value, ...} map.
  function TS(key, fallback, sub) {
    var s = T(key, fallback);
    for (var k in sub) s = s.split(k).join(String(sub[k]));
    return s;
  }
  var PAGE_LANG = I18N.locale || (document.documentElement.lang || 'cs').slice(0, 2);

  // ── DOM refs ──
  var variantInput = document.getElementById('chp-variant-id');
  var priceEl = document.getElementById('chp-price');
  var atcBtn = document.getElementById('chp-atc-btn');
  var atcText = document.getElementById('chp-atc-text');
  var qtyInput = document.getElementById('chp-qty-input');
  var qtyMinus = document.getElementById('chp-qty-minus');
  var qtyPlus = document.getElementById('chp-qty-plus');
  var form = document.getElementById('chp-form');

  // ── Helpers ──
  // The presentment currency comes from Liquid (cart.currency): Kč for the
  // Czech market, € for the EUR markets. Hardcoding Kč here once showed
  // Slovak visitors euro amounts labelled as crowns.
  var moneyEl = document.getElementById('chp-variant-data');
  var MONEY_SUFFIX = (moneyEl && moneyEl.dataset.currencySymbol) || 'Kč';
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0' + MONEY_SUFFIX;
  }

  function getQty() {
    return Math.max(1, parseInt(qtyInput ? qtyInput.value : '1', 10) || 1);
  }

  // ── Motion ──
  // One easing for every change on the page: a long, soft settle. Nothing
  // moves on load, and nothing moves at all for visitors who ask their
  // system for less motion.
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  // The photo's tags follow the buy box: when it opens (launch time, or a
  // restock seen in the live data) the matching tag goes, and the tag row
  // with it once empty.
  function dropBadge(sel) {
    var tag = document.querySelector('[data-chp-badges] ' + sel);
    if (!tag) return;
    var row = tag.parentNode;
    tag.remove();
    if (!row.querySelector('.ev-badge')) row.remove();
  }

  // ── Glide: one dark pill that travels to the active choice ──
  // Shared by the size buttons and the CZ / SK / EU switch. Instead of one
  // button going dark while another goes light, a single pill slides from
  // the old choice to the new one and the labels change colour as it
  // arrives. The pill sits behind the buttons, which turn transparent over
  // it (CSS: .has-glide). Returns place(animate).
  function Glide(container, activeSel) {
    var pill = document.createElement('span');
    pill.className = 'chp-glide';
    pill.setAttribute('aria-hidden', 'true');
    container.insertBefore(pill, container.firstChild);
    container.classList.add('has-glide');
    function place(animate) {
      var active = container.querySelector(activeSel);
      if (!active || !active.offsetWidth) { pill.style.opacity = '0'; return; }
      pill.style.transition = animate && !REDUCED
        ? 'transform 560ms ' + EASE + ', width 560ms ' + EASE + ', height 560ms ' + EASE + ', opacity 200ms ease'
        : 'none';
      pill.style.width = active.offsetWidth + 'px';
      pill.style.height = active.offsetHeight + 'px';
      pill.style.transform = 'translate(' + active.offsetLeft + 'px, ' + active.offsetTop + 'px)';
      pill.style.opacity = '1';
    }
    place(false);
    // Re-measure whenever the row changes size (fonts arriving, a gated buy
    // box opening, a rotated phone); the row does not change size while the
    // pill travels, so a glide is never cut short.
    if (window.ResizeObserver) new ResizeObserver(function () { place(false); }).observe(container);
    else window.addEventListener('resize', function () { place(false); });
    return place;
  }
  // A crossfade for text that changes under a choice: the old words soften
  // away, the new ones are written while nothing shows, then they come in.
  // Rapid clicks cancel the half-finished swap instead of stacking fades.
  var swapToken = 0;
  function crossfade(els, change) {
    els = els.filter(Boolean);
    if (REDUCED || !els.length || !els[0].animate) { change(); return; }
    var token = ++swapToken;
    var out = els.map(function (el) {
      return el.animate(
        [{ opacity: 1, filter: 'blur(0)' }, { opacity: 0, filter: 'blur(1.5px)' }],
        { duration: 160, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
      );
    });
    out[0].onfinish = function () {
      if (token !== swapToken) return;
      change();
      els.forEach(function (el, i) {
        out[i].cancel();
        el.animate(
          [{ opacity: 0, filter: 'blur(1.5px)', transform: 'translateY(2px)' },
           { opacity: 1, filter: 'blur(0)', transform: 'none' }],
          { duration: 360, easing: EASE }
        );
      });
    };
  }
  // A quiet fade for text that changes under a choice (stock).
  function settleIn(el) {
    if (!el || REDUCED || !el.animate) return;
    el.animate(
      [{ opacity: 0, transform: 'translateY(3px)' }, { opacity: 1, transform: 'none' }],
      { duration: 380, easing: EASE }
    );
  }

  // ── Price: every digit on its own drum ──
  // A digit that changes rolls to its new value, upwards when the price rises
  // and downwards when it falls, one drum a beat after the other from the
  // left, with a hint of motion blur. Digits that stay the same stay still.
  // Screen readers get the plain amount through aria-label.
  function odoDrum(pos) {
    var drum = document.createElement('span');
    drum.className = 'chp-odo__d';
    drum.setAttribute('aria-hidden', 'true');
    var strip = document.createElement('span');
    strip.className = 'chp-odo__strip';
    for (var i = 0; i < 20; i++) {       // 0-9 twice, so a roll can wrap 9 -> 0
      var n = document.createElement('span');
      n.textContent = i % 10;
      strip.appendChild(n);
    }
    drum.appendChild(strip);
    strip.style.transform = 'translateY(' + (-pos * 5) + '%)';
    return drum;
  }
  function odoChar(ch) {
    var c = document.createElement('span');
    c.className = 'chp-odo__c';
    c.setAttribute('aria-hidden', 'true');
    c.textContent = ch;
    return c;
  }
  var isDigit = function (ch) { return ch >= '0' && ch <= '9'; };
  // One counter per price on the page: the big price, and on a phone the
  // price in the button and in the sticky bar.
  function Odometer(priceEl) {
  var priceShown = priceEl ? priceEl.textContent.trim() : '';
  var priceRollTimer = null;
  return function renderPrice(text, animate) {
    if (!priceEl) return;
    var from = priceShown;
    priceShown = text;
    priceEl.setAttribute('aria-label', text);
    if (!animate || REDUCED || from === text || !from) { priceEl.textContent = text; return; }

    var up = (parseInt(from.replace(/\D/g, ''), 10) || 0) <= (parseInt(text.replace(/\D/g, ''), 10) || 0);
    var offset = text.length - from.length;       // line the two up from the right
    var frag = document.createDocumentFragment();
    var rolls = [];
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      var old = from.charAt(i - offset);
      if (!isDigit(ch)) { frag.appendChild(odoChar(ch)); continue; }
      var to = +ch;
      var was = isDigit(old) ? +old : null;
      if (was === to) { frag.appendChild(odoChar(ch)); continue; }
      var start = was === null ? (up ? 0 : 10) : (up ? was : was + 10);
      var end = up ? (to >= start ? to : to + 10) : (to + 10 <= start ? to + 10 : to);
      var drum = odoDrum(start);
      if (was === null) drum.style.opacity = '0';
      frag.appendChild(drum);
      rolls.push({ drum: drum, end: end, to: to, fresh: was === null });
    }
    priceEl.textContent = '';
    priceEl.appendChild(frag);
    priceEl.classList.add('is-rolling');

    void priceEl.offsetWidth;                     // commit the start positions
    var DUR = 820, STEP = 55;
    rolls.forEach(function (r, k) {
      var strip = r.drum.firstChild;
      var delay = k * STEP;
      strip.style.transition = 'transform ' + DUR + 'ms ' + EASE + ' ' + delay + 'ms';
      strip.style.transform = 'translateY(' + (-r.end * 5) + '%)';
      if (strip.animate) {
        strip.animate(
          [{ filter: 'blur(0)' }, { filter: 'blur(0.7px)', offset: 0.35 }, { filter: 'blur(0)' }],
          { duration: DUR, delay: delay, easing: 'ease-in-out' }
        );
      }
      if (r.fresh) {
        r.drum.style.transition = 'opacity 320ms ease ' + delay + 'ms';
        r.drum.style.opacity = '1';
      }
    });
    clearTimeout(priceRollTimer);
    priceRollTimer = setTimeout(function () {
      if (priceShown !== text) return;            // a newer change took over
      priceEl.classList.remove('is-rolling');
      priceEl.textContent = text;                 // back to plain text at rest
    }, DUR + rolls.length * STEP + 60);
  };
  }
  var renderPrice = Odometer(priceEl);

  // The phone's button and sticky bar carry the total too, without ",00".
  var atcPriceEl = document.getElementById('chp-atc-price');
  var renderAtcPrice = Odometer(atcPriceEl);
  var renderStickyPrice = null; // set by the sticky bar below
  var syncSticky = null;        // likewise
  function shortMoney(cents) {
    return formatMoney(cents).replace(/,00(?=\u00A0)/, '');
  }

  function updatePrice(animate) {
    if (!priceEl) return;
    var unit = parseInt(priceEl.dataset.unitPrice, 10) || 0;
    renderPrice(formatMoney(unit * getQty()), animate !== false);
    var total = shortMoney(unit * getQty());
    renderAtcPrice(total, animate !== false);
    if (renderStickyPrice) renderStickyPrice(total, animate !== false);
  }

  // ── Variant / Option Picker (one row per option category) ──
  var variants = [];
  try {
    var dataEl = document.getElementById('chp-variant-data');
    if (dataEl) variants = JSON.parse(dataEl.textContent) || [];
  } catch (e) { variants = []; }

  var optionGroups = Array.prototype.slice.call(
    document.querySelectorAll('.chp__weight-picker[data-option-position]')
  );

  function getSelection() {
    var sel = [];
    optionGroups.forEach(function (group) {
      var pos = parseInt(group.dataset.optionPosition, 10);
      var active = group.querySelector('.chp__weight-btn--active');
      sel[pos - 1] = active ? active.dataset.value : null;
    });
    return sel;
  }

  function variantMatches(v, sel) {
    for (var j = 0; j < sel.length; j++) {
      if (sel[j] != null && v.options[j] !== sel[j]) return false;
    }
    return true;
  }

  function findVariant(sel) {
    for (var i = 0; i < variants.length; i++) {
      if (variantMatches(variants[i], sel)) return variants[i];
    }
    return null;
  }

  // ── Live stock tier, the same five the shared snippet renders on the server
  // (snippets/stock-state.liquid): "Skladem 5 ks a více" from twenty up, the
  // real count below it with the dot going green → orange → red. ──
  var stockEl = document.getElementById('chp-stock');
  var stockLabelEl = document.getElementById('chp-stock-label');
  function stockInfo(v) {
    if (!v || !v.available) return { level: 'out', label: T('stock_out', 'Vyprodáno') };
    var qty = v.inv;
    if (v.track && typeof qty === 'number' && qty > 0 && qty < 20) {
      if (qty < 5) return { level: 'crit', label: TS('stock_last_n', 'Poslední __N__ ks', { '__N__': qty }) };
      return {
        level: qty < 12 ? 'low' : 'ok',
        label: TS('stock_in_n', 'Skladem __N__ ks', { '__N__': qty }),
      };
    }
    return { level: 'plenty', label: T('stock_in_min', 'Skladem 5 ks a více') };
  }
  function renderStock(v) {
    if (!stockEl || !stockLabelEl) return;
    var si = stockInfo(v);
    stockEl.className = 'ev-stock ev-stock--' + si.level + ' chp__stock';
    var changed = stockLabelEl.textContent !== si.label;
    stockLabelEl.textContent = si.label;
    if (changed && stockAnimate) settleIn(stockEl);
  }
  var stockAnimate = false;

  // Strike option values that can't form an available variant given the OTHER
  // currently-selected options. Kept clickable, so there are no dead ends.
  function refreshAvailability(sel) {
    optionGroups.forEach(function (group) {
      var idx = parseInt(group.dataset.optionPosition, 10) - 1;
      group.querySelectorAll('.chp__weight-btn').forEach(function (btn) {
        var probe = sel.slice();
        probe[idx] = btn.dataset.value;
        var ok = variants.some(function (v) {
          return v.available && variantMatches(v, probe);
        });
        btn.classList.toggle('chp__weight-btn--unavailable', !ok);
      });
    });
  }

  // ── Variant image ──
  // One picture in the hero. #chp-variant-images (from the section) maps each
  // variant id to its image; the picker swaps the picture in place, and the
  // other variants' images are fetched in the background right after load so
  // the swap is instant.
  var heroImg = document.getElementById('chp-hero-img');
  var VARIANT_IMAGES = {};
  try {
    var vimgEl = document.getElementById('chp-variant-images');
    if (vimgEl) VARIANT_IMAGES = JSON.parse(vimgEl.textContent) || {};
  } catch (e) { VARIANT_IMAGES = {}; }
  var switchToken = 0;
  var imageAnimate = false;
  function showVariantImage(variantId) {
    var entry = heroImg && VARIANT_IMAGES[String(variantId)];
    if (!entry || !entry.src) return;
    if (heroImg.getAttribute('src') === entry.src) return;
    var token = ++switchToken;
    var probe = new Image();
    probe.sizes = heroImg.sizes || '';
    probe.srcset = entry.srcset || '';
    probe.src = entry.src;
    var swap = function () {
      if (token !== switchToken) return; // a newer choice won
      var box = heroImg.parentNode;
      var stale = box.querySelector('.chp__img--ghost');
      if (stale) stale.remove();
      // The outgoing bag stays on top as a copy and falls back (a touch
      // smaller, softly blurred) while the new one settles in from a slight
      // lift with the blur clearing: one picture turning into the next.
      var ghost = null;
      if (imageAnimate && !REDUCED && heroImg.animate) {
        ghost = heroImg.cloneNode(false);
        ghost.removeAttribute('id');
        ghost.classList.add('chp__img--ghost');
        ghost.setAttribute('aria-hidden', 'true');
        ghost.style.cssText = 'position:absolute;margin:0;max-width:none;pointer-events:none;' +
          'left:' + heroImg.offsetLeft + 'px;top:' + heroImg.offsetTop + 'px;' +
          'width:' + heroImg.offsetWidth + 'px;height:' + heroImg.offsetHeight + 'px;';
        box.appendChild(ghost);
      }
      heroImg.setAttribute('srcset', entry.srcset || '');
      heroImg.setAttribute('src', entry.src);
      heroImg.setAttribute('alt', entry.alt || heroImg.alt);
      if (!ghost) return;
      ghost.animate(
        [{ opacity: 1, transform: 'scale(1)', filter: 'blur(0)' },
         { opacity: 0, transform: 'scale(0.965)', filter: 'blur(5px)' }],
        { duration: 440, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' }
      ).onfinish = function () { ghost.remove(); };
      heroImg.animate(
        [{ opacity: 0, transform: 'translateY(10px) scale(1.015)', filter: 'blur(5px)' },
         { opacity: 1, transform: 'none', filter: 'blur(0)' }],
        { duration: 720, delay: 80, easing: EASE, fill: 'backwards' }
      );
    };
    if (probe.complete) swap(); else { probe.onload = swap; probe.onerror = swap; }
  }
  function prefetchVariantImages() {
    Object.keys(VARIANT_IMAGES).forEach(function (id) {
      var entry = VARIANT_IMAGES[id];
      if (!entry || !entry.src || (heroImg && heroImg.getAttribute('src') === entry.src)) return;
      var im = new Image();
      im.sizes = (heroImg && heroImg.sizes) || '';
      im.srcset = entry.srcset || '';
      im.src = entry.src;
    });
  }
  if (heroImg && Object.keys(VARIANT_IMAGES).length > 1) {
    if ('requestIdleCallback' in window) requestIdleCallback(prefetchVariantImages);
    else setTimeout(prefetchVariantImages, 800);
  }

  function applySelection(pushUrl) {
    // pushUrl is true only for a visitor's own choice: that is what animates.
    stockAnimate = imageAnimate = !!pushUrl;
    var sel = getSelection();
    refreshAvailability(sel);
    var variant = findVariant(sel);

    if (variant) {
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) { priceEl.dataset.unitPrice = variant.price; updatePrice(!!pushUrl); }

      var compareEl = document.getElementById('chp-compare-price');
      var pctEl = document.getElementById('chp-discount-pct');
      if (compareEl) {
        if (variant.compare_at && variant.compare_at > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at);
          compareEl.style.display = '';
          if (pctEl) {
            var pct = Math.round((1 - variant.price / variant.compare_at) * 100);
            pctEl.textContent = '\u2212' + pct + ' %';
            pctEl.style.display = pct > 0 ? '' : 'none';
          }
        } else {
          compareEl.style.display = 'none';
          if (pctEl) pctEl.style.display = 'none';
        }
      }

      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.classList.toggle('is-unavailable', !variant.available);
      }
      if (atcText) atcText.textContent = variant.available ? T('atc_add', 'Přidat do košíku') : T('atc_soldout', 'Vyprodáno');

      renderStock(variant);
      showVariantImage(variant.id);

      if (pushUrl) {
        var url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    } else {
      if (atcBtn) { atcBtn.disabled = true; atcBtn.classList.add('is-unavailable'); }
      if (atcText) atcText.textContent = T('atc_unavailable', 'Nedostupné');
    }
    if (syncSticky) syncSticky();
  }

  // ── Option buttons: the shared glide (see Glide above) ──
  function placeGlide(group, animate) { if (group._glide) group._glide(animate); }
  optionGroups.forEach(function (group) {
    if (group.querySelectorAll('.chp__weight-btn').length < 2) return;
    group._glide = Glide(group, '.chp__weight-btn--active');
  });

  optionGroups.forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.chp__weight-btn');
      if (!btn) return;
      group.querySelectorAll('.chp__weight-btn').forEach(function (b) {
        b.classList.remove('chp__weight-btn--active');
      });
      btn.classList.add('chp__weight-btn--active');
      placeGlide(group, true);
      applySelection(true);
    });

    group.setAttribute('role', 'radiogroup');

    group.addEventListener('keydown', function (e) {
      var btns = Array.prototype.slice.call(group.querySelectorAll('.chp__weight-btn'));
      var idx = btns.findIndex(function (b) { return b.classList.contains('chp__weight-btn--active'); });
      var next = idx;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (idx + 1) % btns.length; e.preventDefault(); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (idx - 1 + btns.length) % btns.length; e.preventDefault(); }
      if (next !== idx && btns[next]) { btns[next].click(); btns[next].focus(); }
    });
  });

  // Restore selection from ?variant= in the URL.
  var urlVariant = new URLSearchParams(window.location.search).get('variant');
  if (urlVariant && variants.length) {
    var matchV = variants.filter(function (x) { return String(x.id) === String(urlVariant); })[0];
    if (matchV) {
      optionGroups.forEach(function (group) {
        var want = matchV.options[parseInt(group.dataset.optionPosition, 10) - 1];
        group.querySelectorAll('.chp__weight-btn').forEach(function (b) {
          b.classList.toggle('chp__weight-btn--active', b.dataset.value === want);
        });
        placeGlide(group, false);
      });
    }
  }

  // Sync price / availability / URL from the server-rendered selection.
  if (optionGroups.length) applySelection(false);

  // Reconcile against live inventory. The server-rendered data paints
  // instantly, but a cached page can show stale stock; this pulls the live
  // product JSON and corrects availability + price, then re-renders. Fails
  // silently and keeps the rendered data on any network/parse error.
  if (dataEl && dataEl.dataset.jsUrl && variants.length) {
    var liveUrl = dataEl.dataset.jsUrl;
    liveUrl += (liveUrl.indexOf('?') < 0 ? '?' : '&') + '_=' + Date.now();
    fetch(liveUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (live) {
        if (!live || !live.variants) return;
        var byId = {};
        live.variants.forEach(function (lv) { byId[String(lv.id)] = lv; });
        var changed = false;
        variants.forEach(function (v) {
          var lv = byId[String(v.id)];
          if (!lv) return;
          if (v.available !== lv.available) { v.available = lv.available; changed = true; }
          if (typeof lv.price === 'number' && v.price !== lv.price) { v.price = lv.price; changed = true; }
          // Markets propagates compare-at lazily and reports null meanwhile;
          // only adopt a live compare-at when it actually carries a value,
          // never clear the server-rendered one on null.
          if (typeof lv.compare_at_price === 'number' && lv.compare_at_price > 0 && (v.compare_at || 0) !== lv.compare_at_price) {
            v.compare_at = lv.compare_at_price;
            changed = true;
          }
        });
        if (changed) applySelection(false);
        // Cached sold-out pages: the server rendered the waitlist gate while
        // stock was zero, and (unlike coming-soon) nothing time-based removes
        // it. The live data is authoritative: if anything is buyable now,
        // drop the gate right here so restocks never look sold out.
        var gatedCol = document.querySelector('.chp__col--gated');
        if (gatedCol && !gatedCol.dataset.comingSoonAt) {
          var anyAvail = variants.some(function (vv) { return vv.available; });
          if (anyAvail) {
            gatedCol.classList.add('chp__col--unlocked');
            gatedCol.classList.remove('chp__col--gated');
            dropBadge('[data-chp-soldout-badge]');
          }
        }
      })
      .catch(function () {});
  }

  // ── Coming soon: auto-unlock the buy box at launch ──
  // The server gates the buy controls (.chp__col--gated) + shows the waitlist
  // when the launch metafield is in the future. At the launch moment we drop
  // the gate, revealing the (pre-initialised) buy box, which also self-corrects
  // a cached page whose launch has already passed. A sold-out gate has no
  // launch time, so it stays until the product is restocked + the page reloads.
  (function () {
    var col = document.querySelector('.chp__col--right');
    if (!col || !col.classList.contains('chp__col--gated')) return;
    var launchMs = (parseInt(col.dataset.comingSoonAt || '0', 10) || 0) * 1000;
    if (!launchMs) return; // sold-out gate, not time-based
    var done = false;
    function unlock(animated) {
      if (done) return;
      done = true;
      if (animated) col.classList.add('chp__col--unlocked');
      col.classList.remove('chp__col--gated');
      dropBadge('.ev-badge--coming');
      clearInterval(timer);
    }
    // Cached page whose launch already passed: correct instantly, no fanfare.
    if (Date.now() >= launchMs) { unlock(false); return; }
    // Live moment: reveal the buy box with its entrance animation.
    var timer = setInterval(function () {
      if (Date.now() >= launchMs) unlock(true);
    }, 1000);
    // Background tabs throttle intervals; the instant the tab is back,
    // re-check so nobody stares at a stale waitlist after the launch.
    function recheck() { if (Date.now() >= launchMs) unlock(true); }
    document.addEventListener('visibilitychange', recheck);
    window.addEventListener('focus', recheck);
    window.addEventListener('pageshow', recheck);
  })();

  // ── Coming soon: the launch countdown line ──
  // One large line in the heading face ("2 · Velký čas"), ticking once a
  // second. The days drop off on the last day, hours stay padded. When it
  // hits zero the line leaves; the unlock above reveals the buy box at the
  // same moment. aria-hidden: screen readers get the launch sentence under
  // it, which says "dnes" / "zítra" by the visitor's clock (Prague days).
  (function () {
    var el = document.querySelector('[data-launch-count]');
    if (!el) return;
    var at = (parseInt(el.dataset.launchAt || '0', 10) || 0) * 1000;
    if (!at || Date.now() >= at) { el.remove(); return; }
    var dEl = el.querySelector('[data-lc-d]');
    var dLab = el.querySelector('[data-lc-dlab]');
    var hEl = el.querySelector('[data-lc-h]');
    var mEl = el.querySelector('[data-lc-m]');
    var sEl = el.querySelector('[data-lc-s]');
    var dCell = el.querySelector('[data-lc-cell-d]');
    var line = document.querySelector('[data-launch-line]');
    var dayOf = function (ms) {
      try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Prague' }).format(new Date(ms)); }
      catch (e) { return new Date(ms).toISOString().slice(0, 10); }
    };
    var lineSet = '';
    function relLine() {
      if (!line) return;
      var today = dayOf(Date.now());
      var launchDay = dayOf(at);
      var key = launchDay === today ? 'today' : launchDay === dayOf(Date.now() + 864e5) ? 'tomorrow' : '';
      if (!key || key === lineSet) return;
      var txt = line.getAttribute('data-line-' + key);
      if (txt) { line.textContent = txt.replace(/&nbsp;/g, '\u00a0'); lineSet = key; }
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    var timer = null;
    function tick() {
      var left = at - Date.now();
      if (left <= 0) {
        el.remove();
        if (timer) clearInterval(timer);
        return;
      }
      var t = Math.floor(left / 1000);
      var d = Math.floor(t / 86400); t -= d * 86400;
      var h = Math.floor(t / 3600); t -= h * 3600;
      var m = Math.floor(t / 60); t -= m * 60;
      if (d > 0) {
        dEl.textContent = d;
        dLab.textContent = d === 1 ? T('day_one', 'den') : d < 5 ? T('day_few', 'dny') : T('day_other', 'dní');
        dCell.hidden = false;
      } else {
        dCell.hidden = true;
      }
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(t);
      relLine();
    }
    tick();
    el.hidden = false;
    timer = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
    window.addEventListener('focus', tick);
  })();

  // ── Waitlist / notify signup → app endpoint (KV + Shopify customer sync) ──
  // Posts to the worker's /api/waitlist/subscribe so the email lands in the
  // app's newsletter DB AND gets pushed to the Shopify customer base + email
  // marketing list (handled server-side). NOT a Shopify {% form 'customer' %}.
  (function () {
    var wrap = document.querySelector('[data-notify]');
    if (!wrap) return;
    var form = wrap.querySelector('[data-notify-form]');
    if (!form) return;
    var emailEl = wrap.querySelector('[data-notify-email]');
    var consentEl = wrap.querySelector('[data-notify-consent]');
    var hpEl = wrap.querySelector('[data-notify-hp]');
    var msgEl = wrap.querySelector('[data-notify-msg]');
    var btn = wrap.querySelector('[data-notify-submit]');
    var ENDPOINT = 'https://evelina.kavaevelina.workers.dev/api/waitlist/subscribe';
    var comingSoon = wrap.dataset.comingSoon === '1';

    function msg(text, ok) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.hidden = false;
      msgEl.classList.toggle('is-ok', !!ok);
      msgEl.classList.toggle('is-err', !ok);
    }
    function succeed(already) {
      var title = already ? T('wl_already_title', 'Už jste na seznamu') : (comingSoon ? T('wl_coming_title', 'Jste na seznamu') : T('wl_watch_title', 'Hlídáme to za vás'));
      var text = already ? T('wl_already_text', 'Díky. Ozveme se vám.') : (comingSoon ? T('wl_coming_text', 'Ozveme se vám mezi prvními.') : T('wl_watch_text', 'Ozveme se, jakmile bude skladem.'));
      form.innerHTML =
        '<div class="chp__notify-done">' +
        '<span class="chp__notify-done-mark" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.5 12L13 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<p class="chp__notify-done-title">' + title + '</p>' +
        '<p class="chp__notify-done-text">' + text + '</p>' +
        '</div>';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl && emailEl.value || '').trim();
      if (!email) { msg(T('wl_err_email', 'Zadejte e-mail.'), false); return; }
      if (consentEl && !consentEl.checked) { msg(T('wl_err_consent', 'Potvrďte prosím souhlas.'), false); return; }
      if (btn) btn.disabled = true;
      if (msgEl) msgEl.hidden = true;

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId: parseInt(wrap.dataset.productId, 10),
          productHandle: wrap.dataset.productHandle || '',
          productTitle: wrap.dataset.productTitle || '',
          email: email,
          consent: !!(consentEl && consentEl.checked),
          locale: (document.documentElement.lang || 'cs').slice(0, 2),
          hp_company: hpEl ? hpEl.value : ''
        })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, d: d }; });
        })
        .then(function (res) {
          if (res.status === 200 && res.d && res.d.ok) {
            succeed(!!res.d.already);
          } else {
            if (btn) btn.disabled = false;
            msg((res.d && res.d.error) || T('wl_err_generic', 'Něco se nepovedlo, zkuste to prosím znovu.'), false);
          }
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          msg(T('wl_err_network', 'Nepovedlo se odeslat. Zkontrolujte připojení.'), false);
        });
    });
  })();

  // ── Quantity Picker ──
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) { qtyInput.value = v - 1; updatePrice(); }
    });

    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v < 99) { qtyInput.value = v + 1; updatePrice(); }
    });

    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) qtyInput.value = 1;
      else if (v > 99) qtyInput.value = 99;
      updatePrice();
    });
  }

  // ── Freshness Badge + Roast Date ──
  // The pill carries data-roast-date (product metafield custom.roast_date)
  // when the roast date is known. Then it reads "Praženo 14. 9." in the
  // visitor's locale, is coloured by age (fresh up to 14 days, good up to 30,
  // aging after) and its tooltip says how long ago. Without a date the pill
  // stays the static "Čerstvě praženo" rendered by Liquid.
  (function () {
    var badge = document.getElementById('chp-freshness-badge');
    var raw = badge && (badge.dataset.roastDate || '').trim();
    if (!badge || !raw) return;
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(raw);
    if (!m) return;
    var roastDate = new Date(+m[1], +m[2] - 1, +m[3]);
    if (isNaN(roastDate.getTime())) return;

    var p = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Prague' }));
    var today = new Date(p.getFullYear(), p.getMonth(), p.getDate());
    var days = Math.round((today - roastDate) / 86400000);
    var formatted = roastDate.toLocaleDateString(PAGE_LANG, { day: 'numeric', month: 'numeric' });
    var ago = days === 0 ? T('ago_today', 'dnes')
      : days === 1 ? T('ago_one', 'před 1 dnem')
      : TS('ago_days', 'před __N__ dny', { '__N__': days });

    var tip, state;
    if (days < 0) {
      badge.textContent = T('fresh_preparing', 'Připravujeme');
      state = 'fresh';
      tip = T('tt_preparing', 'Pražíme v malých dávkách těsně před odesláním, aby byla káva pokaždé čerstvá.');
    } else {
      badge.textContent = TS('fresh_roasted_on', 'Praženo __D__', { '__D__': formatted });
      if (days <= 14) {
        state = 'fresh';
        tip = TS('tt_fresh', 'Pražíme v malých dávkách, aby byla káva pokaždé čerstvá. Upraženo __AGO__.', { '__AGO__': ago });
      } else if (days <= 30) {
        state = 'good';
        tip = TS('tt_good', 'Pražíme v malých dávkách pro maximální čerstvost. Upraženo __AGO__.', { '__AGO__': ago });
      } else {
        state = 'aging';
        tip = TS('tt_aging', 'Upraženo __AGO__.', { '__AGO__': ago });
      }
    }
    badge.className = 'chp__freshness-badge chp__freshness-badge--' + state;
    badge.setAttribute('data-tip', tip);
    badge.title = TS('days_since', '__N__ dní od pražení', { '__N__': Math.max(days, 0) });
  })();

  // ── Delivery Calculator with SK/CZ holidays ──
  (function () {
    var deliveryEl = document.getElementById('chp-delivery');
    var regionBox = document.querySelector('[data-chp-region]');
    var regionBtn = regionBox && regionBox.querySelector('[data-chp-region-btn]');
    var regionMenu = regionBox && regionBox.querySelector('[role="listbox"]');
    var regionOpts = regionMenu ? Array.prototype.slice.call(regionMenu.querySelectorAll('[role="option"]')) : [];
    var regionName = document.querySelector('[data-chp-region-name]');
    var infoEl = document.getElementById('chp-delivery-info');
    var dateEl = document.getElementById('chp-delivery-date');
    var roastDateEl = document.getElementById('chp-roast-date-delivery');

    if (!regionBox || !deliveryEl) return;

    // The delivery model and its engine (snippets/ev-delivery-model.liquid,
    // assets/eta.js, both from the worker): the same days and hours the
    // e-mails and the customer portal promise, learned from our own parcels.
    // Without them (a blocked or cached-out script) the page keeps its old
    // rule below: the 10:00 cutoff, then 1 / 2 / 4 business days.
    var MODEL = null;
    try {
      var modelEl = document.querySelector('[data-ev-delivery-model]');
      MODEL = modelEl ? JSON.parse(modelEl.textContent || 'null') : null;
    } catch (e) { MODEL = null; }
    var REGION_CC = { cz: 'CZ', sk: 'SK', eu: deliveryEl.dataset.euCc || 'DE' };
    function isoDay(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function fromIso(v) { var x = String(v).split('-'); return new Date(+x[0], +x[1] - 1, +x[2]); }
    // One region's promise for an order placed now, or null without the engine.
    function etaFor(region) {
      var E = window.EvelinaEta;
      if (!E || !E.predict) return null;
      try {
        return E.predict(MODEL, { cc: REGION_CC[region] || 'CZ', fixed: overrideShip ? isoDay(overrideShip) : null });
      } catch (e) { return null; }
    }

    var skDays = 2, czDays = 1, euDays = 4;
    var dispatchEl = document.getElementById('chp-delivery-dispatch');
    var etaEl = document.getElementById('chp-delivery-eta');

    // Fixed holidays for Slovakia (MM-DD)
    var skHolidays = [
      '01-01', // Deň vzniku SR
      '01-06', // Traja králi
      '05-01', // Sviatok práce
      '05-08', // Deň víťazstva
      '07-05', // Sv. Cyril a Metod
      '08-29', // SNP
      '09-01', // Deň Ústavy SR
      '09-15', // Sedembolestná Panna Mária
      '11-01', // Všetkých svätých
      '11-17', // Deň boja za slobodu
      '12-24', // Štedrý deň
      '12-25', // Prvý sviatok vianočný
      '12-26'  // Druhý sviatok vianočný
    ];

    // Fixed holidays for Czech Republic (MM-DD)
    var czHolidays = [
      '01-01', // Nový rok / Den obnovy
      '05-01', // Sviatok práce
      '05-08', // Den vítězství
      '07-05', // Cyril a Metoděj
      '07-06', // Den upálení Jana Husa
      '09-28', // Den české státnosti
      '10-28', // Den vzniku Československa
      '11-17', // Den boje za svobodu
      '12-24', // Štědrý den
      '12-25', // 1. svátek vánoční
      '12-26'  // 2. svátek vánoční
    ];

    // Easter Monday calculation (Gauss algorithm for Western Easter)
    function getEasterMonday(year) {
      var a = year % 19;
      var b = Math.floor(year / 100);
      var c = year % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      // Easter Sunday
      var easter = new Date(year, month - 1, day);
      // Easter Monday = +1
      var easterMonday = new Date(easter);
      easterMonday.setDate(easter.getDate() + 1);
      return easterMonday;
    }

    // Good Friday = Easter Sunday - 2
    function getGoodFriday(year) {
      var a = year % 19;
      var b = Math.floor(year / 100);
      var c = year % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      var easter = new Date(year, month - 1, day);
      var goodFriday = new Date(easter);
      goodFriday.setDate(easter.getDate() - 2);
      return goodFriday;
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function formatDateKey(d) {
      return pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }

    function isHoliday(date, holidays, year) {
      var key = formatDateKey(date);
      if (holidays.indexOf(key) !== -1) return true;

      // Check Easter Monday (both SK and CZ)
      var em = getEasterMonday(year);
      if (date.getMonth() === em.getMonth() && date.getDate() === em.getDate()) return true;

      // Check Good Friday (CZ has it since 2016, SK has it too)
      var gf = getGoodFriday(year);
      if (date.getMonth() === gf.getMonth() && date.getDate() === gf.getDate()) return true;

      return false;
    }

    // Same-day dispatch cutoff (Europe/Prague), configurable in the theme.
    var cutoffHour = parseInt(deliveryEl.dataset.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 10;

    // Temporary manual override from the theme editor: one date (YYYY-MM-DD)
    // that replaces the computed dispatch day on EVERY product, e.g. while we
    // wait for a roast. Arrival is then counted from that day, so the whole
    // line stays consistent. Anything unparseable falls back to the cutoff
    // logic rather than showing a broken date.
    // Two possible fixed dates: the shop-wide one (data-dispatch-override) and
    // this coffee's own (data-dispatch-product, metafield custom.dispatch_date).
    // The later one that still lies ahead wins; a date already gone is
    // ignored, so once both have passed the cutoff logic is back on its own.
    var overrideShip = (function () {
      function parse(raw) {
        var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((raw || '').trim());
        if (!m) return null;
        var d = new Date(+m[1], +m[2] - 1, +m[3]);
        if (isNaN(d.getTime()) || d.getMonth() !== +m[2] - 1) return null;
        return d;
      }
      var p = pragueNow();
      var today = new Date(p.getFullYear(), p.getMonth(), p.getDate());
      var ahead = [parse(deliveryEl.dataset.dispatchOverride), parse(deliveryEl.dataset.dispatchProduct)]
        .filter(function (d) { return d && d.getTime() >= today.getTime(); });
      if (!ahead.length) return null;
      return ahead.sort(function (a, b) { return b.getTime() - a.getTime(); })[0];
    })();

    function pragueNow() {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Prague' }));
    }
    function isBizDay(d, holidays) {
      return d.getDay() !== 0 && d.getDay() !== 6 && !isHoliday(d, holidays, d.getFullYear());
    }
    function nextBizDay(d, holidays) {
      var x = new Date(d);
      do { x.setDate(x.getDate() + 1); } while (!isBizDay(x, holidays));
      return x;
    }
    function addBizDays(start, n, holidays) {
      var d = new Date(start), added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (isBizDay(d, holidays)) added++;
      }
      return d;
    }
    // When the parcel leaves the CZ warehouse: today if it's a business day and
    // we are before the cutoff, otherwise the next business day.
    function shipInfo() {
      var e = etaFor(currentRegion);   // the dispatch day is the same for every country
      if (e) return { today: e.today, forced: e.forced, date: fromIso(e.dispatch) };
      if (overrideShip) return { today: false, forced: true, date: new Date(overrideShip) };
      var p = pragueNow();
      var today = new Date(p.getFullYear(), p.getMonth(), p.getDate());
      if (isBizDay(today, czHolidays) && p.getHours() < cutoffHour) return { today: true, date: today };
      return { today: false, date: nextBizDay(today, czHolidays) };
    }
    var CZ_WEEKDAY_IN = {
      1: T('wd_in_1', 'v pondělí'), 2: T('wd_in_2', 'v úterý'), 3: T('wd_in_3', 've středu'),
      4: T('wd_in_4', 've čtvrtek'), 5: T('wd_in_5', 'v pátek')
    };
    var CZ_WEEKDAY_NOM = {
      1: T('wd_nom_1', 'pondělí'), 2: T('wd_nom_2', 'úterý'), 3: T('wd_nom_3', 'středa'),
      4: T('wd_nom_4', 'čtvrtek'), 5: T('wd_nom_5', 'pátek')
    };
    function shipsTomorrow(d) {
      var p = pragueNow();
      var t = new Date(p.getFullYear(), p.getMonth(), p.getDate() + 1);
      return d.getFullYear() === t.getFullYear() && d.getMonth() === t.getMonth() && d.getDate() === t.getDate();
    }
    function shortDate(d) { return d.getDate() + '. ' + (d.getMonth() + 1) + '.'; }
    // The cutoff is 10:00 in Prague, but a visitor in London or New York
    // should read it on their own clock. This is the real moment of today's
    // cutoff: Prague's wall clock at the cutoff hour, shifted by the gap
    // between Prague's clock and this device's.
    function cutoffInstant() {
      var p = pragueNow();
      var gap = Math.round((Date.now() - p.getTime()) / 60000) * 60000;
      var wall = new Date(p.getFullYear(), p.getMonth(), p.getDate(), cutoffHour, 0, 0, 0);
      return new Date(wall.getTime() + gap);
    }
    function localTime(d) {
      return d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    }
    // "When we ship" clause
    function dispatchClause(ship) {
      if (ship.forced) {
        var fwd = CZ_WEEKDAY_IN[ship.date.getDay()];
        return TS('ship_on', '[[Expedujeme __D__]]', { '__D__': (fwd ? fwd + ' ' : '') + shortDate(ship.date) });
      }
      if (ship.today) return TS('order_by', 'Objednejte do __TIME__ a [[odešleme dnes]]', { '__TIME__': localTime(cutoffInstant()) });
      if (shipsTomorrow(ship.date)) return T('ship_tomorrow', '[[Odesíláme zítra]]');
      return TS('ship_weekday', '[[Odesíláme __WD__]]', { '__WD__': CZ_WEEKDAY_IN[ship.date.getDay()] || T('asap', 'co nejdříve') });
    }
    // The copy marks the words to set in bold with [[ ]]: when it leaves reads
    // as strongly as when it arrives. Everything else is escaped first, so the
    // marker is the only markup that can get through.
    function emphasise(text) {
      var safe = String(text || '')
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      return safe.replace(/\[\[([\s\S]+?)\]\]/g, '<strong>$1</strong>');
    }
    // "U vás v úterý 22. 9." with the day underlined (the preposition
    // stays outside the line), or "U vás zítra".
    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    function arrivalHead(arrival) {
      var when;
      if (shipsTomorrow(arrival)) {
        when = '<u>' + esc(T('tomorrow', 'zítra')) + '</u>';
      } else {
        var wd = CZ_WEEKDAY_IN[arrival.getDay()] || '';
        var sp = wd.indexOf(' ');
        var prep = sp > 0 ? wd.slice(0, sp + 1) : '';
        var day = sp > 0 ? wd.slice(sp + 1) : wd;
        when = esc(prep) + '<u>' + esc((day ? day + ' ' : '') + shortDate(arrival)) + '</u>';
      }
      return esc(T('arrive_head', 'U vás __WHEN__')).split('__WHEN__').join(when);
    }

    function getDeliveryDate(bizDays, holidays) {
      var d = new Date();
      var toAdd = bizDays + 1; // +1 for shipping day
      var cet = new Date(d.toLocaleString('en-US', { timeZone: 'Europe/Prague' }));
      if (cet.getHours() >= cutoffHour) toAdd++; // after cutoff, ships next day

      var added = 0;
      while (added < toAdd) {
        d.setDate(d.getDate() + 1);
        var year = d.getFullYear();
        if (d.getDay() !== 0 && d.getDay() !== 6 && !isHoliday(d, holidays, year)) {
          added++;
        }
      }
      return d;
    }

    function formatDeliveryDate(d) {
      return d.toLocaleDateString(PAGE_LANG, { weekday: 'long', day: 'numeric', month: 'long' });
    }

    var currentRegion = 'cz';
    // A tab left in the background can miss ticks; catch up when it returns.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) update(currentRegion);
    });

    function arrivalFor(region, ship) {
      var e = etaFor(region);
      if (e) return fromIso(e.likely);
      var transitDays, destHolidays;
      if (region === 'cz') {
        transitDays = czDays;
        destHolidays = czHolidays;
      } else if (region === 'eu') {
        transitDays = euDays;
        destHolidays = czHolidays; // transit calendar approximated with CZ
      } else {
        transitDays = skDays;
        destHolidays = skHolidays;
      }
      return addBizDays(ship.date, transitDays, destHolidays);
    }
    // Thin data (the rest of the EU): "U vás 29. 10. až 2. 11.", not one day.
    function arrivalRange(e) {
      return esc(T('arrive_range', 'U vás __FROM__ až __TO__'))
        .split('__FROM__').join('<u>' + esc(shortDate(fromIso(e.likely))) + '</u>')
        .split('__TO__').join('<u>' + esc(shortDate(fromIso(e.latest))) + '</u>');
    }
    function rangeShort(e) {
      return TS('range_short', '__FROM__ až __TO__', { '__FROM__': shortDate(fromIso(e.likely)), '__TO__': shortDate(fromIso(e.latest)) });
    }
    // Under the date: "Na výdejním místě obvykle do 16:00". The hour only where
    // the data holds it (about 87 % of parcels there by then). The latest day
    // is not shown on the product page (owner, 2026-10-22); the e-mails and the
    // order pages still name it.
    function renderEta(e) {
      if (!etaEl) return;
      var parts = [];
      if (e && !e.range && e.hour != null) {
        parts.push(TS(e.svc === 'point' ? 'eta_hour_point' : 'eta_hour_home', e.svc === 'point' ? 'Na výdejním místě obvykle do __TIME__' : 'Obvykle do __TIME__', { '__TIME__': e.hour + ':00' }));
      }
      var text = parts.join(', ');
      etaEl.textContent = text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
      etaEl.hidden = !text;
    }
    // "úterý 22. 9." or "zítra", for each country in the menu.
    function arrivalShort(arrival) {
      if (shipsTomorrow(arrival)) return T('tomorrow', 'zítra');
      var wd = CZ_WEEKDAY_NOM[arrival.getDay()];
      return (wd ? wd + ' ' : '') + shortDate(arrival);
    }

    // ── The order-by line (owner, 2026-10-22: design "a" of three tried) ──
    // Every day has a real deadline: the next cutoff (10:00 Prague) on the
    // day the parcel would leave. Missing it moves the arrival a day later,
    // so the time left only ever states a true fact. Inside the last 24 hours
    // the dispatch line counts it down ("Objednejte během 15 h 49 min a
    // odešleme zítra"); further off it names the day ("Objednejte do pondělí
    // 10:00 a odešleme v pondělí"). A fixed dispatch date keeps its own line.
    var DAY_MS = 24 * 3600 * 1000;
    // The moment the parcel's own day closes: the cutoff hour on that day in
    // Prague, on this device's clock (as cutoffInstant does for today).
    function cutoffOn(d) {
      var p = pragueNow();
      var gap = Math.round((Date.now() - p.getTime()) / 60000) * 60000;
      return new Date(new Date(d.getFullYear(), d.getMonth(), d.getDate(), cutoffHour, 0, 0, 0).getTime() + gap);
    }
    function leftWords(ms) {
      var mins = Math.max(1, Math.ceil(ms / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      return h ? TS('dl_left_hm', '__H__ h __M__ min', { '__H__': h, '__M__': m }) : TS('dl_left_m', '__M__ min', { '__M__': m });
    }
    // "dnes" / "zítra" / "v pondělí": when it leaves.
    function shipWhen(ship) {
      if (ship.today) return T('dl_today', 'dnes');
      if (shipsTomorrow(ship.date)) return T('tomorrow', 'zítra');
      return CZ_WEEKDAY_IN[ship.date.getDay()] || T('asap', 'co nejdříve');
    }
    // "10:00" / "zítřka 10:00" / "pondělí 10:00": until when to order.
    function deadlineWords(ship, at) {
      var time = localTime(at);
      if (ship.today) return time;
      if (shipsTomorrow(ship.date)) return TS('dl_by_tomorrow', 'zítřka __TIME__', { '__TIME__': time });
      return TS('dl_by_weekday', '__WD__ __TIME__', { '__WD__': T('dl_wd_gen_' + ship.date.getDay(), ''), '__TIME__': time });
    }
    var dlTimer = null, dlShip = null;
    function renderOrderBy() {
      var ship = dlShip;
      if (!ship || ship.forced || !dispatchEl) return;
      var at = cutoffOn(ship.date), left = at.getTime() - Date.now();
      if (left <= 0) { update(currentRegion); return; }   // the deadline just passed: next day's
      var when = shipWhen(ship);
      dispatchEl.innerHTML = emphasise(left <= DAY_MS
        ? TS('dl_within', 'Objednejte během [[__LEFT__]] a odešleme __WHEN__', { '__LEFT__': leftWords(left), '__WHEN__': when })
        : TS('dl_by', 'Objednejte do [[__DEADLINE__]] a odešleme __WHEN__', { '__DEADLINE__': deadlineWords(ship, at), '__WHEN__': when }));
    }
    function startOrderBy(ship) {
      dlShip = ship;
      renderOrderBy();
      if (!dlTimer) dlTimer = setInterval(renderOrderBy, 15000);
    }

    function update(region) {
      currentRegion = region;
      var ship = shipInfo();                                   // leaves the CZ warehouse
      var arrival = arrivalFor(region, ship);
      var eta = etaFor(region);
      if (dispatchEl) dispatchEl.innerHTML = emphasise(dispatchClause(ship));
      if (infoEl) infoEl.innerHTML = eta && eta.range ? arrivalRange(eta) : arrivalHead(arrival);
      renderEta(eta);
      regionOpts.forEach(function (o) {
        var when = o.querySelector('[data-chp-region-when]');
        var oe = etaFor(o.dataset.value);
        if (when) when.textContent = oe && oe.range ? rangeShort(oe) : arrivalShort(arrivalFor(o.dataset.value, ship));
      });
      if (window.__chpShipShow) window.__chpShipShow(region);
      startOrderBy(ship);
    }

    // Format roast date nicely
    if (roastDateEl && deliveryEl.dataset.roastDate) {
      var rd = new Date(deliveryEl.dataset.roastDate);
      if (!isNaN(rd.getTime())) {
        roastDateEl.textContent = rd.toLocaleDateString(PAGE_LANG, { day: 'numeric', month: 'long', year: 'numeric' });
      }
    }

    // ── The country menu ──
    // A button ("Česko ⌄") opens a short list, each country with its own
    // arrival day. Arrows move, Enter or a tap chooses, Escape or a tap
    // outside closes. It opens under the button, or above it when the screen
    // has no room below, and never runs off the side of the screen.
    function optIndex(el) { return regionOpts.indexOf(el); }
    function selectedIndex() {
      for (var i = 0; i < regionOpts.length; i++) if (regionOpts[i].getAttribute('aria-selected') === 'true') return i;
      return 0;
    }
    // Measured from the button and the menu's layout size (not its
    // on-screen box, which the opening animation scales).
    function placeMenu() {
      regionMenu.classList.remove('is-up');
      var vw = document.documentElement.clientWidth;
      var box = regionBox.getBoundingClientRect();
      var w = regionMenu.offsetWidth, h = regionMenu.offsetHeight;
      var shift = 0;
      if (box.left + w > vw - 12) shift = (vw - 12) - (box.left + w);
      if (box.left + shift < 12) shift = 12 - box.left;
      regionMenu.style.left = shift + 'px';
      if (box.bottom + 8 + h > window.innerHeight - 12 && box.top - 8 - h > 12) regionMenu.classList.add('is-up');
    }
    function onOutside(e) {
      if (!regionBox.contains(e.target)) closeMenu(false);
    }
    function openMenu(focusAt) {
      if (!regionMenu.hidden) return;
      regionMenu.hidden = false;
      regionBox.classList.add('is-open');
      regionBtn.setAttribute('aria-expanded', 'true');
      placeMenu();
      var i = typeof focusAt === 'number' ? focusAt : selectedIndex();
      if (regionOpts[i]) regionOpts[i].focus({ preventScroll: true });
      document.addEventListener('pointerdown', onOutside, true);
      window.addEventListener('resize', onResize);
    }
    function closeMenu(focusButton) {
      if (regionMenu.hidden) return;
      regionMenu.hidden = true;
      regionBox.classList.remove('is-open');
      regionBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', onOutside, true);
      window.removeEventListener('resize', onResize);
      if (focusButton) regionBtn.focus({ preventScroll: true });
    }
    function onResize() { closeMenu(false); }
    function choose(opt) {
      var region = opt.dataset.value;
      closeMenu(true);
      if (region === regionBox.dataset.value) return;
      regionBox.dataset.value = region;
      regionOpts.forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
      if (regionName) regionName.textContent = opt.querySelector('.chp__dl-opt-name').textContent;
      crossfade(
        [infoEl, document.getElementById('chp-delivery-sub')],
        function () { update(region); }
      );
    }
    regionBtn.addEventListener('click', function () {
      if (regionMenu.hidden) openMenu(); else closeMenu(true);
    });
    regionBtn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        openMenu();
      }
    });
    regionMenu.addEventListener('click', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (opt) choose(opt);
    });
    regionMenu.addEventListener('keydown', function (e) {
      var i = optIndex(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); regionOpts[(i + 1) % regionOpts.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); regionOpts[(i - 1 + regionOpts.length) % regionOpts.length].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); regionOpts[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); regionOpts[regionOpts.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (regionOpts[i]) choose(regionOpts[i]); }
      else if (e.key === 'Escape') { e.preventDefault(); closeMenu(true); }
      else if (e.key === 'Tab') { closeMenu(false); }
    });

    update(regionBox.dataset.value || 'cz');
  })();

  // ── Shipping line per region (live from the worker) ──
  // One sentence under the arrival date: who delivers, from how much, and
  // from what order total it is free. Carriers come from the checkout's own
  // rates, reduced to their names, so the page never promises a carrier the
  // checkout does not offer.
  (function () {
    var line = document.querySelector('[data-ship-line]');
    if (!line) return;
    var fallbackCarrier = { cz: line.dataset.czCarrier, sk: line.dataset.skCarrier, eu: line.dataset.euCarrier };
    var rates = null;

    function money(amount, currency) {
      if (amount == null) return null;
      if (currency === 'EUR') return (amount % 1 === 0 ? String(amount) : amount.toFixed(2).replace('.', ',')) + ' €';
      if (currency === 'CZK') return Math.round(amount).toLocaleString('cs-CZ') + ' Kč';
      return amount + ' ' + currency;
    }
    // Packeta is Zásilkovna at home; a Slovak page spells it its own way.
    function carrierName(id, region) {
      if (id === 'dpd') return 'DPD';
      if (region !== 'cz') return 'Packeta';
      return PAGE_LANG === 'sk' ? 'Zásielkovňa' : PAGE_LANG === 'en' ? 'Packeta' : 'Zásilkovna';
    }
    function carriersFor(region, r) {
      var seen = {}, ids = [];
      (r.carriers || []).forEach(function (name) {
        var n = String(name || '').toLowerCase();
        var id = /z[aá]silkovn|z[aá]sielkov|packeta/.test(n) ? 'packeta' : /\bdpd\b/.test(n) ? 'dpd' : null;
        if (id && !seen[id]) { seen[id] = true; ids.push(id); }
      });
      ids.sort(function (a, b) { return (a === 'packeta' ? 0 : 1) - (b === 'packeta' ? 0 : 1); });
      return ids.length
        // A sentence, not a label: "Zásilkovna a DPD", "Packeta and DPD".
        ? ids.map(function (id) { return carrierName(id, region); }).join(PAGE_LANG === 'en' ? ' and ' : ' a ')
        : (fallbackCarrier[region] || '');
    }
    function show(region) {
      if (!rates) return;
      var r = rates[region] || rates.cz || {};
      var carrier = carriersFor(region, r);
      var from = money(r.amount, r.currency);
      var free = money(r.freeAmount, r.freeCurrency);
      var text = carrier && from ? TS('ship_short', '__CARRIER__ od __FROM__', { __CARRIER__: carrier, __FROM__: from }) : '';
      if (free) text += (text ? ', ' : '') + TS('free_short', 'nad __FREE__ doprava zdarma', { __FREE__: free });
      line.textContent = text;
      line.hidden = !text;
    }
    window.__chpShipShow = show;

    // ?v= changes whenever the rates change, so no browser keeps an old copy.
    fetch('https://evelina.kavaevelina.workers.dev/api/shipping/lowest?v=2')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || d.error) return;
        rates = d;
        var sel = document.querySelector('[data-chp-region]');
        show((sel && sel.dataset.value) || 'cz');
      })
      .catch(function () {});
  })();

  // ── Add to Cart ──
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atcBtn.disabled) return;
      atcBtn.disabled = true;

      var fd = new FormData(form);
      // Ask Shopify to render the cart sections in the same round trip, the
      // way the theme's own product forms do, so the drawer opens already
      // showing the new line instead of the previous cart.
      var sectionIds = Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map(function (el) { return el.dataset.sectionId; })
        .filter(Boolean);
      if (sectionIds.length) {
        fd.append('sections', sectionIds.join(','));
        fd.append('sections_url', window.location.pathname);
      }
      var addedQty = parseInt(fd.get('quantity'), 10) || 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      })
        .then(function (r) {
          if (!r.ok) throw new Error('ATC failed');
          return r.json();
        })
        .then(function (res) {
          atcBtn.classList.add('chp__atc-btn--success');
          // Same announcement the theme's product forms make: cart items morph
          // in, the header bubble adds the quantity, the drawer opens.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: res, sourceId: 'coffee-hero', data: { source: 'product-form-component', itemCount: addedQty, sections: res.sections } }
          }));
          var cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') cartDrawer.open();
            else if (typeof cartDrawer.showDialog === 'function') cartDrawer.showDialog();
          }

          if (qtyInput) qtyInput.value = 1;
          updatePrice();

          setTimeout(function () {
            atcBtn.classList.remove('chp__atc-btn--success');
            atcBtn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          atcBtn.disabled = false;
          atcBtn.style.animation = 'chp-shake 0.4s ease';
          setTimeout(function () { atcBtn.style.animation = ''; }, 400);
        });
    });
  }

  // ── Sticky buy bar (phones) ──
  // Once the buy button has scrolled above the screen, a slim bar slides up
  // with the size switch and "Do košíku · 949 Kč". It holds no state of its
  // own: a size tap clicks the real size button, the button clicks the real
  // add-to-cart, and it mirrors their state back. It steps aside at the
  // footer, while the buy box is gated, and on wider screens.
  (function () {
    var bar = document.querySelector('[data-chp-sticky]');
    if (!bar || !atcBtn || !('IntersectionObserver' in window)) return;
    var cta = bar.querySelector('[data-chp-sticky-cta]');
    var sizes = Array.prototype.slice.call(bar.querySelectorAll('.chp-sticky__size'));
    var group = optionGroups[0] || null;
    var mq = window.matchMedia('(max-width: 749px)');
    var past = false, atEnd = false;
    renderStickyPrice = Odometer(bar.querySelector('[data-chp-sticky-price]'));

    function sync() {
      var active = group && group.querySelector('.chp__weight-btn--active');
      sizes.forEach(function (b) {
        var on = !!active && b.getAttribute('data-value') === active.dataset.value;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var unavailable = atcBtn.classList.contains('is-unavailable');
      bar.classList.toggle('is-unavailable', unavailable);
      bar.classList.toggle('is-added', atcBtn.classList.contains('chp__atc-btn--success'));
      cta.disabled = unavailable;
    }
    function show() {
      var on = mq.matches && past && !atEnd && !document.querySelector('.chp__col--gated');
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      show();
    }).observe(atcBtn);
    var foot = document.querySelector('.cf') || document.querySelector('footer');
    if (foot) {
      new IntersectionObserver(function (entries) {
        atEnd = entries[entries.length - 1].isIntersecting;
        show();
      }).observe(foot);
    }
    if (mq.addEventListener) mq.addEventListener('change', show);

    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!group) return;
        var want = b.getAttribute('data-value');
        var target = Array.prototype.filter.call(group.querySelectorAll('.chp__weight-btn'), function (x) {
          return x.dataset.value === want;
        })[0];
        if (target && !target.classList.contains('chp__weight-btn--active')) target.click();
      });
    });
    cta.addEventListener('click', function () {
      if (!atcBtn.disabled) atcBtn.click();
    });
    new MutationObserver(sync).observe(atcBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });

    syncSticky = sync;
    sync();
  })();

  // ── Wide screens: where the buy column pins ──
  // Under the header when it fits on the screen; a column taller than the
  // screen pins by its bottom instead (it scrolls until its end shows, then
  // stays), so the button and the delivery never sit out of reach. It stops
  // above the recommended coffees: as they come up, the pin point moves up
  // with them, so the column leaves with the section above. (The grid area
  // alone should stop it, but Safari measures a sticky box inside
  // display: contents wrappers against the whole page.)
  (function () {
    var col = document.querySelector('.chp__col--right');
    if (!col) return;
    var mq = window.matchMedia('(min-width: 1100px)');
    var stopAt = document.querySelector('main > .ui-test-product-list');
    var header = document.querySelector('.header');
    var queued = false;
    function place() {
      queued = false;
      if (!mq.matches) { col.style.removeProperty('--chp-buy-top'); return; }
      var hb = header ? header.getBoundingClientRect().bottom : 0;
      var top = Math.max(0, Math.min(hb, 140)) + 20;
      var h = col.offsetHeight;
      top = Math.min(top, window.innerHeight - h - 24);
      if (stopAt) top = Math.min(top, stopAt.getBoundingClientRect().top - 40 - h);
      col.style.setProperty('--chp-buy-top', Math.round(top) + 'px');
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(place);
    }
    place();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (mq.addEventListener) mq.addEventListener('change', queue);
    if (window.ResizeObserver) new ResizeObserver(queue).observe(col);
  })();

  // ── Back to the coffees ──  // ── Back to the coffees ──
  // The browser's own back when the previous page was on this shop (the list
  // comes back where it was scrolled); the collection link otherwise.
  (function () {
    var back = document.querySelector('[data-chp-back]');
    if (!back) return;
    back.addEventListener('click', function (e) {
      var ref = document.referrer;
      if (!ref || history.length < 2) return;
      try { if (new URL(ref).origin !== location.origin) return; } catch (err) { return; }
      e.preventDefault();
      history.back();
    });
  })();

  // ── Roast scale: the ⓘ, and a tap on a step where there is no hover ──
  // A mouse gets every card from :hover in CSS; this adds the two ways that
  // hover cannot cover. The ⓘ pins this coffee's own card (and the hint to
  // walk the scale) for a finger, a keyboard, or a deliberate click. A finger
  // also opens any step by tapping it; tapping again, tapping elsewhere or
  // Escape closes.
  (function () {
    var noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
    function closeRoast() {
      var open = document.querySelectorAll('.chp__rst-step.is-tip');
      for (var i = 0; i < open.length; i++) open[i].classList.remove('is-tip');
      var guided = document.querySelectorAll('.chp__rst.is-guided');
      for (var j = 0; j < guided.length; j++) guided[j].classList.remove('is-guided');
      var btns = document.querySelectorAll('[data-chp-roast-info][aria-expanded="true"]');
      for (var k = 0; k < btns.length; k++) btns[k].setAttribute('aria-expanded', 'false');
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var info = t.closest('[data-chp-roast-info]');
      if (info) {
        var block = info.closest('[data-chp-roast]');
        var here = block && block.querySelector('.chp__rst-step.is-here');
        var opening = here && !here.classList.contains('is-tip');
        closeRoast();
        if (opening) {
          here.classList.add('is-tip');
          block.classList.add('is-guided');
          info.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      var step = noHover ? t.closest('[data-chp-roast] .chp__rst-step') : null;
      var wasOpen = step && step.classList.contains('is-tip');
      closeRoast();
      if (step && !wasOpen) step.classList.add('is-tip');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') closeRoast();
    });
  })();

  // Shake keyframe
  if (!document.getElementById('chp-kf')) {
    var s = document.createElement('style');
    s.id = 'chp-kf';
    s.textContent = '@keyframes chp-shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}';
    document.head.appendChild(s);
  }
})();
